import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Plane, Search, LayoutDashboard, MessageSquare, LogOut, Shield, LogIn, Settings as SettingsIcon } from "lucide-react";

export default function AppShell({ children }) {
  const { user, signOut } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const navItem = (to, label, Icon, testid) => {
    const active = loc.pathname === to || (to !== "/" && loc.pathname.startsWith(to));
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition ${active ? "text-white bg-slate-800/70" : "text-slate-400 hover:text-white hover:bg-slate-800/40"}`}
      >
        <Icon size={16} /> <span className="hidden sm:inline">{label}</span>
      </Link>
    );
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-40 glass border-b border-slate-800/80">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-4 py-3">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 font-display font-bold text-lg">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-gradient-to-br from-[#FF6B6B] to-[#F59E0B]">
              <Plane size={16} className="text-white" />
            </span>
            <span>TravelBuddy</span>
          </Link>
          <nav className="flex items-center gap-1">
            {navItem("/search", "Chercher", Search, "nav-search")}
            {user && navItem("/dashboard", "Dashboard", LayoutDashboard, "nav-dashboard")}
            {user && navItem("/messages", "Messages", MessageSquare, "nav-messages")}
            {user && navItem("/settings", "Paramètres", SettingsIcon, "nav-settings")}
            {user?.is_admin && navItem("/admin", "Admin", Shield, "nav-admin")}
          </nav>
          <div className="flex items-center gap-2">
            {user ? (
              <>
                <span className="hidden md:inline text-xs text-slate-400">{user.name}</span>
                <button
                  data-testid="nav-logout"
                  onClick={() => { signOut(); nav("/"); }}
                  className="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800/60"
                  title="Se déconnecter"
                >
                  <LogOut size={16} />
                </button>
              </>
            ) : (
              <Link to="/login" data-testid="nav-login" className="btn-coral px-3 py-2 rounded-lg text-sm flex items-center gap-2">
                <LogIn size={14} /> Connexion
              </Link>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1">
        {children}
      </main>

      <footer className="border-t border-slate-800/60 mt-16 py-8 text-center text-xs text-slate-500">
        <div className="max-w-6xl mx-auto px-4">
          <p>© 2026 TravelBuddy — L'annuaire du voyageur. Mise en relation uniquement — aucune détention de fonds.</p>
          <div className="mt-2 flex justify-center gap-4">
            <Link to="/about" data-testid="footer-about" className="hover:text-white">Qui sommes-nous</Link>
            <Link to="/terms" data-testid="footer-terms" className="hover:text-white">CGU</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
